export const CHECKOUT_MULTI_STEP_FLAG = 'checkout-multi-step-flow';
export const CHECKOUT_REARRANGE_STEPS_FLAG = 'checkout-rearrange-steps-flow';
export const NCCT_STEPS_FLAG = 'checkout-ncct-steps-flow';
